import API_URLS from '../config/apiConfig';
import { authApiRequest } from './authService/authApiRequest';
import type { NewAgentRow, WatchdogConfigPayload } from '../types/features/newAgents';

const watchdogConfigService = {
  getConfigs: async (includeRegistered: boolean): Promise<NewAgentRow[]> => {
    const response = await authApiRequest(API_URLS.GET_WATCHDOG_CONFIGS(includeRegistered));
    return Array.isArray(response) ? response as NewAgentRow[] : [];
  },

  getConfig: async (wifiMacAddress: string): Promise<NewAgentRow> => {
    return await authApiRequest(API_URLS.GET_WATCHDOG_CONFIG(wifiMacAddress)) as NewAgentRow;
  },

  updateConfig: async (wifiMacAddress: string, payload: WatchdogConfigPayload): Promise<NewAgentRow> => {
    return await authApiRequest(API_URLS.UPDATE_WATCHDOG_CONFIG(wifiMacAddress), {
      method: 'PUT',
      body: payload,
    }) as NewAgentRow;
  },
};

export default watchdogConfigService;
